import React from "react"
import PropTypes from 'prop-types';
import { Alert } from '../components';

export class NotifyProvider extends React.Component {
  static childContextTypes = {
    notificator: PropTypes.object.isRequired
  }

  state = {
    message: null
  }

  componentWillReceiveProps(props) {
    const { message } = this.state;
    const { error } = props;

    if (error != null) {
      this.message(error, 'error');
    }
  }

  getChildContext() {
    return { notificator: { message: this.message } }
  }

  onClose = () =>
    this.refs.alert.className = 'hidden';

  message = (text, type='success') => {
    this.refs.alert.className = '';
    this.setState({message: {type: type, text: text}})
  }


  render() {
    const { message } = this.state;

    return (
      <div>
        <div ref="alert" className="">
          {message != null &&
            <Alert text={message.text} type={message.type}
                   icon="close" onClick={this.onClose}/>
          }
        </div>

        {this.props.children}
      </div>
    );
  }
};
